import { render } from "./customized.vue?vue&type=template&id=61446fae&scoped=true"
import script from "./customized.vue?vue&type=script&lang=js"
export * from "./customized.vue?vue&type=script&lang=js"

import "./customized.vue?vue&type=style&index=0&id=61446fae&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61446fae"],['__file',"src/views/form/components/customized.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61446fae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61446fae', __exports__)) {
    console.log('reload')
    api.reload('61446fae', __exports__)
  }
  
  module.hot.accept("./customized.vue?vue&type=template&id=61446fae&scoped=true", () => {
    console.log('re-render')
    api.rerender('61446fae', render)
  })

}


export default __exports__